// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","header-nav":"Header_header-nav__2zBNu","link":"Header_link__1uLZ-"};